import { Component, OnInit } from '@angular/core';
import { LoginRequest } from '../_models/auth/loginRequest';
import { AuthenticationService } from '../_services/authentication.service';
import { MessageService, Message, ConfirmationService } from 'primeng/api';
import { Usuario } from '../_models/usuario/usuario';
import { JwtResponse } from '../_models/auth/jwtResponse';
import { Router } from '@angular/router';
import { UsuarioService } from '../_services/usuario.service';
import { BscobrancaTranslate } from 'src/app/_services/bscobrancatranslate';
import { UsuarioResponse } from '../_models/response/usuarioResponse';

@Component({
  selector: 'app-login',
  templateUrl: 'app.login.component.html',
  providers: [MessageService, ConfirmationService]
})
export class AppLoginComponent implements OnInit {

  loginRequest: LoginRequest;
  msgs: Message[] = [];
  usuario: Usuario;
  captchaOK: boolean;
  trocarSenhaDialog: boolean;

  constructor(private authenticationService: AuthenticationService, private messageService: MessageService,
              private router: Router, private confirmationService: ConfirmationService, private usuarioService: UsuarioService,
              private bscobrancaTranslate: BscobrancaTranslate) {
  }

  ngOnInit(): void {
    this.loginRequest = {};
  }

  showResponse(event) {
    this.captchaOK = true;
  }

  validateLogin() {
    if (!this.loginRequest.username) {
      return 'O username deve ser informado!';
    }
    if (!this.loginRequest.password) {
      return 'A senha deve ser informada!';
    }
    /**if (!this.captchaOK) {
      return 'O Captcha deve ser selecionado!';
    }*/
    return '';
  }

  login() {
    const message = this.validateLogin();
    if (message !== '') {
      this.msgs = [];
      this.msgs.push({ severity: 'error', summary: 'Erro:', detail: message });
    } else {
      this.authenticationService.loginAuth(this.loginRequest).subscribe(
        (jwtResponse: JwtResponse) => {
          if (jwtResponse) {
            if (jwtResponse.codigo === 0) {
              this.usuario = jwtResponse.usuario;
              this.authenticationService.storageUser(jwtResponse);
            } else {
              this.msgs = [];
              this.msgs.push({ severity: 'error', summary: 'Erro:', detail: jwtResponse.mensagem });
            }
          }
        });
    }
  }

  openDialog() {
    this.trocarSenhaDialog = true;
  }


  hideDialog() {
    this.trocarSenhaDialog = false;
  }

  validateEmail(email) {
    const emailRegex = RegExp(/^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/);
    const regularExpression = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return regularExpression.test(String(email).toLowerCase());
  }

  resetPass() {
    this.messageService.clear();
    if(this.loginRequest.username && this.validateEmail(this.loginRequest.username)) {
      this.confirmationService.confirm({
            message: this.bscobrancaTranslate.getText('login.confirmaEnvio'),
            header: 'Confirm',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
              const usuarioRes: Usuario = {};
              usuarioRes.dscEmail = this.loginRequest.username;
              this.usuarioService.resetSenha(usuarioRes).subscribe(
                    (usuarioResponse: UsuarioResponse) => {
                        if (usuarioResponse) {
                            if (usuarioResponse.codigo === 0) {
                                this.messageService.add({
                                    severity: 'success', summary: 'Successful', detail: usuarioResponse.mensagem, life: 3000});
                                this.trocarSenhaDialog = false;
                            } else {
                                this.messageService.add({ severity: 'error', summary: 'Error', detail: usuarioResponse.mensagem,
                                life: 3000 });
                            }
                        } else {
                            this.messageService.add({
                                severity: 'error', summary: 'Error', detail: this.bscobrancaTranslate.getText('login.erroSenha'),
                                life: 3000
                            });
                        }
                    });
            }
        });
    } else {
      this.messageService.add({
        severity: 'error', summary: 'Error', detail: this.bscobrancaTranslate.getText('login.emailvazio'), life: 3000});
    }
  }
}
